export function mapURLSearchParams(
  params: URLSearchParams,
  keysToRemove: string[] = []
) {
  const mapped = new URLSearchParams(params);
  keysToRemove.forEach((key: string) => mapped.delete(key));
  return mapped;
}
